export default __webpack_public_path__ + "static/brand-9-eb5b87080c6aa632e10922f056155deb.png";